import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import GraphComponent from "./chart/chart";
import "./adminDashboard.scss";
import { useNavigate } from "react-router-dom";

const AdminDashboard = () => {
  const [userData, setUserData] = useState({});
  const [restaurantData, setRestaurantData] = useState({});
  const [orders, setOrders] = useState({});
  const [userSelectedChartData, setUserSelectedChartData] = useState([]);
  const [restaurantSelectedChartData, setRestaurantSelectedChartData] =
    useState([]);
  const [ordersSelectedChartData, setOrdersSelectedChartData] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchDataSummary = async () => {
      try {
        const response = await fetch(
          "https://femez.onrender.com/API/admin/adminDashboard?periods=week,month,year,all",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        const data = await response.json();
        console.log(data);

        // Separate user data and restaurant data
        const userData = {};
        const restaurantData = {};
        const ordersData = {};
        Object.keys(data).forEach((key) => {
          if (key.startsWith("users")) {
            userData[key] = data[key];
          } else if (key.startsWith("restaurants")) {
            restaurantData[key] = data[key];
          } else if (key.startsWith("orders")) {
            ordersData[key] = data[key];
          }
        });

        setUserData(userData);
        setRestaurantData(restaurantData);
        setOrders(ordersData);
        setUserSelectedChartData(data.users_all || {});
        setRestaurantSelectedChartData(data.restaurants_all || {});
        setOrdersSelectedChartData(data.orders_all || {});
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataSummary();
  }, []);

  const handleSelectChange = (event, whichDataToDisplay) => {
    console.log(whichDataToDisplay);
    // const selectedOption = event.target.value;
    if (whichDataToDisplay === "users") {
      setUserSelectedChartData(userData[event.target.value] || {});
    } else if (whichDataToDisplay === "restaurants") {
      setRestaurantSelectedChartData(restaurantData[event.target.value] || {});
    } else if (whichDataToDisplay === "orders") {
      setOrdersSelectedChartData(orders[event.target.value] || {});
    }
  };
  const logout = () => {
    const token = localStorage.getItem("token");
    fetch("https://femez.onrender.com/API/user/logOut", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          localStorage.clear();
          sessionStorage.clear();
          navigate(`/`);
        }
        return res.json();
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <div className="admin-dashboard-container">
      <div className="side-bar">
        <h1>Admin Dashboard</h1>
        <div className="user-bar">
          <h1>User Chart</h1>
          <select
            id="userSelector"
            onChange={(event) => handleSelectChange(event, "users")}
          >
            <option value="users_all">All times</option>
            <option value="users_year">Last year</option>
            <option value="users_month">Last month</option>
            <option value="users_week">Last week</option>
          </select>
        </div>
        <div className="restaurant-bar">
          <h1>restaurant Chart</h1>
          <select
            id="restaurantSelector"
            onChange={(event) => handleSelectChange(event, "restaurants")}
          >
            <option value="restaurants_all">All times</option>
            <option value="restaurants_year">Last year</option>
            <option value="restaurants_month">Last month</option>
            <option value="restaurants_week">Last week</option>
          </select>
        </div>
        <div className="orders-bar">
          <h1>orders Chart</h1>
          <select
            id="ordersSelector"
            onChange={(event) => handleSelectChange(event, "orders")}
          >
            <option value="orders_all">All times</option>
            <option value="orders_year">Last year</option>
            <option value="orders_month">Last month</option>
            <option value="orders_week">Last week</option>
          </select>
        </div>
      </div>
      <div className="graphs">
        <div className="logout-container">
          <button className="logout" onClick={logout}>
            Logout
          </button>
        </div>
        <div className="user-graph">
          {Object.keys(userSelectedChartData).length > 0 ? (
            <GraphComponent selectedChartData={userSelectedChartData} />
          ) : (
            <p>Loading...</p>
          )}
        </div>
        <div className="restaurant-graph">
          {Object.keys(restaurantSelectedChartData).length > 0 ? (
            <GraphComponent selectedChartData={restaurantSelectedChartData} />
          ) : (
            <p>Loading...</p>
          )}
        </div>
        <div className="orders-graph">
          {Object.keys(ordersSelectedChartData).length > 0 ? (
            <GraphComponent selectedChartData={ordersSelectedChartData} />
          ) : (
            <p>Loading...</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
